import { Injectable } from '@angular/core';
import { BaseStoreService } from '@src/app/modules/base';

import { LoyaltyProgramCollection } from '../../types';

@Injectable({
  providedIn: 'root',
})
export class LpCollectionsInfoStoreService extends BaseStoreService<LoyaltyProgramCollection> {}
